import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxFoldersViewComponent } from './folders-view.component';

export const ngxFoldersViewModule = angular.module('ngxFoldersViewModule', [])
	.directive('ngxFoldersView', downgradeComponent({component: NgxFoldersViewComponent}))
	.name;
